import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from "prop-types";
import { EuiFocusTrap } from '../../../../src/components/focus_trap';
import { EuiButton } from '../../../../src/components/button';
export var GuideFullScreen = ({
  children,
  isFullScreen = false,
  buttonText = 'Show fullscreen demo',
  onOpen
}) => {
  const [fullScreen, setFullScreen] = useState(isFullScreen); // Watch for fullScreen status and appropriately add/remove body classes for hiding scroll

  useEffect(() => {
    if (fullScreen) {
      document.body.classList.add('guideBody--overflowHidden');
    }

    return () => {
      document.body.classList.remove('guideBody--overflowHidden');
    };
  }, [fullScreen]);

  const openFullScreen = () => {
    setFullScreen(true);

    if (onOpen) {
      onOpen();
    }
  };

  return <Fragment>
      <EuiButton onClick={openFullScreen} iconType="fullScreen">
        {buttonText}
      </EuiButton>

      {fullScreen && <EuiFocusTrap>{children(setFullScreen)}</EuiFocusTrap>}
    </Fragment>;
};
GuideFullScreen.propTypes = {
  children: PropTypes.func.isRequired,
  buttonText: PropTypes.node,
  isFullScreen: PropTypes.bool,
  onOpen: PropTypes.func
};

try {
  // @ts-ignore
  GuideFullScreen.displayName = "GuideFullScreen"; // @ts-ignore

  GuideFullScreen.__docgenInfo = {
    "description": "",
    "displayName": "GuideFullScreen",
    "props": {
      "buttonText": {
        "defaultValue": {
          value: "Show fullscreen demo"
        },
        "description": "",
        "name": "buttonText",
        "required": false,
        "type": {
          "name": "ReactNode"
        }
      },
      "isFullScreen": {
        "defaultValue": {
          value: false
        },
        "description": "",
        "name": "isFullScreen",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "onOpen": {
        "defaultValue": null,
        "description": "",
        "name": "onOpen",
        "required": false,
        "type": {
          "name": "(() => void) | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/services/full_screen/full_screen.tsx#GuideFullScreen"] = {
      docgenInfo: GuideFullScreen.__docgenInfo,
      name: "GuideFullScreen",
      path: "src-docs/src/services/full_screen/full_screen.tsx#GuideFullScreen"
    };
} catch (__react_docgen_typescript_loader_error) {}